/**
 * Sales channel status Icon, support 'draft', 'schedule', 'live' totally 3 icons.
 * Author: Chris
 * CreatedAt: 2021-03-08
 */

import { SalesChannelStatus } from '@/src/types/common/SalesChannel';
import React from 'react';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './SalesChannelStatusIcon.less';

interface IProps {
  status: SalesChannelStatus;
}

const SalesChannelStatusIcon = ({ status }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const statusMapping = {
    [SalesChannelStatus.draft]: 'general.status.draft',
    [SalesChannelStatus.live]: 'general.status.active',
    [SalesChannelStatus.scheduled]: 'general.status.scheduled',
  };
  const getConfig = () => {
    if (status === SalesChannelStatus.draft) {
      return {
        border: '1px solid #FFE58F',
        backgroundColor: '#FFFBE6',
        color: '#FAAD14',
        title: getI18n(statusMapping[status]),
      };
    } else if (
      status === SalesChannelStatus.live ||
      status === SalesChannelStatus.scheduled
    ) {
      return {
        border: '1px solid #B7EB8F',
        backgroundColor: '#F6FFED',
        color: '#52C41A',
        title: getI18n(statusMapping[status]),
      };
    }
  };

  const { border, backgroundColor, color, title } = getConfig();

  return (
    <div className={css.container} style={{ border, backgroundColor, color }}>
      {title}
    </div>
  );
};

export default SalesChannelStatusIcon;
